import { formatDate } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatDatepickerInput } from '@angular/material/datepicker';
import { MatFormFieldControl } from '@angular/material/form-field';
import { debounceTime, filter, map, takeUntil } from 'rxjs';
import { MatFormFieldControlImpl } from '../../ng-material-impl/mat-form-field-control.impl';
import { DateFormControlService } from '../date-form-control.service';
import { IDateFormControlOptions } from '../types/i-date-form-control-options';

const formatToDate: { [format in IDateFormControlOptions['format']]: (value: string) => Date } = {
  "dd/MM/yyyy": (value) => {
    const [day, month, year] = value.split('/');
    return new Date(Number(year), Number(month), Number(day))
  },
  "mm/dd/yyyy": (value) => {
    const [month, day, year] = value.split('/');
    return new Date(Number(year), Number(month), Number(day))
  },
  "yyyy/mm/dd": (value) => {
    const [year, month, day] = value.split('/');

    return new Date(Number(year), Number(month), Number(day))
  }

}

@Component({
  selector: 'ss-date-control',
  templateUrl: './date-control.component.html',
  styleUrls: ['./date-control.component.css'],
  providers: [
    {
      provide: MatFormFieldControl,
      useExisting: DateControlComponent
    }
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DateControlComponent extends MatFormFieldControlImpl<Date> implements OnInit, AfterViewInit {

  @ViewChild('inputRef')
  private _inputRef!: ElementRef<HTMLInputElement>

  @ViewChild(MatDatepickerInput)
  private _datePickerRef!: MatDatepickerInput<any>

  readonly touchedSubject = this._formControlService.touchedSubject;
  readonly valueSubject = this._formControlService.valueSubject;
  readonly formatSubject = this._dateFormControlService.formatSubject;
  readonly readOnlyObs = this._formControlService.readOnlyObs;
  readonly minSubject = this._dateFormControlService.minSubject;

  readonly formattedDateObs = this.valueSubject.pipe(
    filter(Boolean),
    debounceTime(100),
    map((date) => formatDate(date, this.formatSubject.value, 'en-us'))
  )
  constructor(
    private _dateFormControlService: DateFormControlService

  ) {
    super('date')
  }

  ngOnInit(): void {


  }


  ngAfterViewInit(): void {

    this._datePickerRef.dateChange
      .pipe(takeUntil(this._destroy))
      .subscribe(({ value }) => this.valueSubject.next(value))


    this.valueSubject
      .pipe(takeUntil(this._destroy))

      .subscribe((value) => {
        const currentValue = this._datePickerRef.value;
        if (currentValue === value) {
          return;
        }

        this._datePickerRef.writeValue(value);

      })

    this._formControlService.htmlElementSubject.next(this._inputRef.nativeElement);
    // fromEvent(this._inputRef.nativeElement, 'focusout')
    //   .pipe(
    //     takeUntil(this._destroy),
    //     map(() => this._inputRef.nativeElement.value)
    //   )
    //   .subscribe((value) => {
    //     const format = this.formatSubject.value;

    //     const date = formatToDate[format](value);
    //     this.valueSubject.next(date);

    //   })

  }

  onContainerClick(event: MouseEvent): void {
    this._inputRef.nativeElement.focus();
  }

  ngOnDestroy() {
    this._destroy.next();
    this._destroy.complete();
  }
}
